var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import { Inset, Media, withTheming } from '@doordash/design-language';
import { Layouts } from './types';

var getTemplateColumns = function getTemplateColumns(_ref) {
  var columnCount = _ref.columnCount,
      layout = _ref.layout;

  if (layout === Layouts.Stack) {
    return "flex-direction: column-reverse;";
  }

  var slotColumn = 'auto';
  var spacerColumn = '1fr';

  if (layout === Layouts.Fill) {
    slotColumn = '1fr';
  }

  var columns = [];
  Array.from(Array(columnCount).keys()).forEach(function () {
    return columns.push(slotColumn);
  });

  if (layout === Layouts.Split) {
    columns.splice(1, 0, spacerColumn);
  }

  return "grid-template-columns: ".concat(columns.join(' '), ";");
};

var getDisplay = function getDisplay(_ref2) {
  var layout = _ref2.layout;

  if (layout === Layouts.Stack) {
    return 'display: flex;';
  }

  return 'display: grid;';
};

var getAlignment = function getAlignment(_ref3) {
  var itemAlignment = _ref3.itemAlignment,
      layout = _ref3.layout;
  return layout !== Layouts.Stack ? "align-items: ".concat(itemAlignment, ";") : '';
};

export var ButtonGroupWrapper = withTheming(styled(Inset).attrs(function (props) {
  return _objectSpread({
    size: props.insetSize,
    horizontalSize: props.insetHorizontalSize,
    verticalSize: props.insetVerticalSize
  }, props.insetProps);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n\n  //  The code below is to recreate the css gap property. Once we drop IE 11 support, this can be removed for gap.\n  max-width: none;\n  ", "\n\n  & > * {\n    ", "\n  }\n  ", "\n"])), getDisplay, getTemplateColumns, getAlignment, function (props) {
  return "margin: ".concat(props.itemGap / -2, "px ").concat(props.itemGap / -2, "px;");
}, function (props) {
  return "margin: ".concat(props.itemGap / 2, "px ").concat(props.itemGap / 2, "px;");
}, function (props) {
  return props.useDynamicPadding && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding:\n      ", "px ", "px};\n    ", "\n    ", "\n  "])), props.theme.Spacing.ButtonGroupPaddingVerticalLarge, props.theme.Spacing.ButtonGroupPaddingHorizontalLarge, Media.Tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding:\n        ", "px ", "px};\n    "])), props.theme.Spacing.ButtonGroupPaddingVerticalMedium, props.theme.Spacing.ButtonGroupPaddingHorizontalMedium), Media.Mobile(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      padding:\n        ", "px ", "px};\n    "])), props.theme.Spacing.ButtonGroupPaddingVerticalSmall, props.theme.Spacing.ButtonGroupPaddingHorizontalSmall));
}));
export var ButtonGroupSpacer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0 !important;\n"])));